import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-horizontalWall",
  "use": "icon-horizontalWall-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-horizontalWall\"><path d=\"M160 224a64 64 0 0 1 64-64h576a64 64 0 0 1 64 64v576a64 64 0 0 1-64 64H224a64 64 0 0 1-64-64V224z m256 480H224v96h192v-96z m384 0H480v96h320v-96z m0-160h-192v96h192v-96z m-256 0H224v96h320v-96z m256-160H480v96h320v-96zM224 480h192v-96H224v96z m320-256H224v96h320V224z m256 0h-192v96h192V224z\" p-id=\"1679\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol